<template>
  <div id="pageDashboard">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <!--        <v-flex lg4 sm6 xs12>-->
        <!--          <mini-statistics-->
        <!--            icon="train"-->
        <!--            :title="dashboardStatistics.vehicles_count | infinity"-->
        <!--            :sub-title="$t('dashboard.vehicles')"-->
        <!--            color="primary"-->
        <!--          >-->
        <!--          </mini-statistics>-->
        <!--        </v-flex>-->
        <v-flex lg4 sm6 xs12>
          <mini-statistics
            icon="bug_report"
            :title="dashboardStatistics.active_issues_count | infinity"
            :sub-title="$t('dashboard.activeIssues')"
            color="teal darken-3"
          >
          </mini-statistics>
        </v-flex>
        <v-flex lg4 sm6 xs12>
          <mini-statistics
            icon="bug_report"
            :title="dashboardStatistics.new_issues_count | infinity"
            :sub-title="$t('dashboard.newIssues')"
            color="red darken-3"
          >
          </mini-statistics>
        </v-flex>

        <v-flex lg4 sm6 xs12>
          <v-select
            v-model="selectedFleet"
            label="Wybierz flotę"
            :items="fleets"
            item-text="name"
            item-value="id"
            :total-items="fleetsCount"
            :loading="fleetIsLoading"
            :value="1"
            @change="fetchCoefficientReliabilityQuarterly(selectedFleet)"
          ></v-select>
          <mini-statistics
            icon="square_foot"
            :title="
              coefficientReliabilityQuarterly.vehicle_reliability | percent | infinity
            "
            :sub-title="$t('dashboard.coefficientReliability')"
            color="primary"
          ></mini-statistics>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg8 sm12 xs12>
          <simple-card
            :title="$t('dashboard.overcomeDistance')"
            text-card-style="height: 462px"
          >
            <v-container fill-height grid-list-md text-xs-center>
              <v-layout align-center justify-center row fill-height>
                <v-flex xs12>
                  <v-progress-circular
                    v-if="dashboardChartVehicleDistanceIsLoading"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <v-chart
                    v-if="!dashboardChartVehicleDistanceIsLoading"
                    :options="chartVehiclesDistance"
                    theme="material"
                    autoresize
                  ></v-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </simple-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <simple-card
            :title="$t('dashboard.issuesStatus')"
            text-card-style="height: 462px"
          >
            <v-container fill-height grid-list-md text-xs-center>
              <v-layout align-center justify-center row fill-height>
                <v-flex xs12>
                  <v-progress-circular
                    v-if="dashboardChartIssuesStatusIsLoading"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <v-chart
                    v-if="!dashboardChartIssuesStatusIsLoading"
                    :options="chartIssuesStatus"
                    theme="material"
                    autoresize
                  ></v-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </simple-card>
        </v-flex>
        <v-flex lg12 sm12 xs12>
          <simple-card
            :title="$t('coefficientReadinessReport')"
            :text-card-style="`height: ${chartHeight}px`"
          >
            <v-container flex fill-height grid-list-md text-xs-center>
              <v-layout align-center justify-center row fill-height>
                <v-flex xs12>
                  <v-progress-circular
                    v-if="coefficientReadinessIsLoading"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <v-chart
                    v-if="!coefficientReadinessIsLoading"
                    :options="chartCoefficientReadinessYearly"
                    theme="material"
                    autoresize
                  ></v-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </simple-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import {
  FETCH_DASHBOARD_STATISTICS,
  FETCH_CHART_ISSUES_STATUS,
  FETCH_CHART_VEHICLES_DISTANCE,
  FETCH_COEFFICIENT_RELIABILITY_QUARTERLY,
  FETCH_COEFFICIENT_READINESS_YEARLY,
  FETCH_FLEETS,
} from "../store/actions.type";
import _ from "lodash";
import utils from "@/util";
import paginationMixin from "@/mixins/pagination.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";

export default {
  data() {
    return { selectedFleet: 1 };
  },
  computed: {
    ...mapGetters([
      "dashboardStatistics",
      "dashboardChartVehicleDistance",
      "dashboardChartIssuesStatus",
      "dashboardIsLoading",
      "dashboardChartVehicleDistanceIsLoading",
      "dashboardChartIssuesStatusIsLoading",
      "coefficientReliabilityQuarterly",
      "coefficientReliabilityIsLoading",
      "coefficientReadinessYearly",
      "coefficientReadinessIsLoading",
      "fleets",
      "fleetsCount",
      "fleetIsLoading",
    ]),
    chartVehiclesDistance() {
      return {
        legend: {
          show: true,
        },
        grid: {
          top: 100,
        },
        tooltip: {
          show: true,
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          type: "value",
        },
        series: _.fill(
          Array(
            this.dashboardChartVehicleDistance[0]
              ? Object.keys(this.dashboardChartVehicleDistance[0]).length - 1
              : 0
          ),
          { type: "bar", smooth: true, areaStyle: {} }
        ),
        dataset: {
          source: this.dashboardChartVehicleDistance,
        },
        pagination: {
          sortBy: null,
          descending: false,
        },
      };
    },
    chartIssuesStatus() {
      return {
        legend: {
          show: true,
          formatter: (name) => this.$t("issueStatus." + name),
        },
        tooltip: {
          show: true,
          formatter: (data) =>
            this.$t("issueStatus." + data.name) +
            ": " +
            data.data.count +
            " (" +
            data.percent +
            "%)",
        },
        series: [
          {
            type: "pie",
            encode: {
              itemName: "status",
              value: "count",
              tooltip: "count",
            },
            label: {
              show: false,
            },
          },
        ],
        dataset: {
          source: this.dashboardChartIssuesStatus,
        },
      };
    },
    chartCoefficientReadinessYearly() {
      return {
        legend: {
          show: true,
          formatter: () => this.$t("inaccessibilityInHours"),
        },
        tooltip: {
          show: true,
          formatter: (data) =>
            this.$t("inaccessibilityInHours") +
            ": " +
            data.data.inaccessibility_in_hours +
            " (" +
            utils.percents(data.data.vehicle_readiness) +
            ")",
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} h",
          },
        },
        yAxis: {
          type: "category",
        },
        series: [{ type: "bar" }],
        dataset: {
          dimensions: ["vehicle", "inaccessibility_in_hours"],

          source: this.coefficientReadinessYearly
            .filter((item) => item.inaccessibility_in_hours !== 8000)
            .map((item) => {
              item.vehicle = item.vehicle.name;
              return item;
            })
            .reverse(),
        },
      };
    },
  },
  mixins: [refreshButtonMixin, paginationMixin, searchInputMixin],
  created() {
    this.fetchItems();
  },
  methods: {
    fetchItems() {
      this.fetchStatistics();
      this.fetchChartVehiclesDistance();
      this.fetchChartIssuesStatus();
      this.fetchCoefficientReadinessYearly();
      this.fetchCoefficientReliabilityQuarterly(1);
      this.$store.dispatch(FETCH_FLEETS, [0, 0]);
    },
    fetchStatistics() {
      this.$store.dispatch(FETCH_DASHBOARD_STATISTICS);
    },
    fetchChartVehiclesDistance() {
      this.$store.dispatch(FETCH_CHART_VEHICLES_DISTANCE);
    },
    fetchChartIssuesStatus() {
      this.$store.dispatch(FETCH_CHART_ISSUES_STATUS);
    },
    fetchCoefficientReliabilityQuarterly(fleet) {
      this.$store.dispatch(FETCH_COEFFICIENT_RELIABILITY_QUARTERLY, [
        new Date().getFullYear(),
        Math.ceil((new Date().getMonth() + 1) / 3),
        fleet,
      ]);
    },
    fetchCoefficientReadinessYearly() {
      this.$store.dispatch(FETCH_COEFFICIENT_READINESS_YEARLY, new Date().getFullYear());
    },
  },
};
</script>

<style>
.echarts {
  width: 100%;
  height: 400px;
}
</style>
